<template>
  <v-card title="客户维护">
    <div class="grid-demo">
      <v-form slot="form">
        <!-- <v-row :gutter="24">
          <v-col class="gutter-row" span="6">
            <div class="gutter-box">
              <v-form-item label="客户编号">
                <v-input placeholder="客户编号" v-model="options.khbh"></v-input>
              </v-form-item>
            </div>
          </v-col>
          <v-col class="gutter-row" span="6">
            <div class="gutter-box">
              <v-form-item label="客户名称">
                <v-input placeholder="客户名称" v-model="options.khmc"></v-input>
              </v-form-item>
            </div>
          </v-col>
          <v-col class="gutter-row" span="6">
            <div class="gutter-box">
              <v-form-item  label="　客户地址">
                <v-input placeholder="客户地址" v-model="options.khdz"></v-input>
              </v-form-item>
            </div>
          </v-col>
          <v-col class="gutter-row" span="6">
            <div class="gutter-box">
              <v-form-item  label="社会信用代码">
                <v-input placeholder="社会信用代码" v-model="options.shxydm"></v-input>
              </v-form-item>
            </div>
          </v-col>
        </v-row>
        <v-row :gutter="24">
          <v-col class="gutter-row" span="6">
            <div class="gutter-box">
              <v-form-item label="联系电话">
                <v-input placeholder="联系电话" v-model="options.lxdh"></v-input>
              </v-form-item>
            </div>
          </v-col>
          <v-col class="gutter-row" span="6">
            <div class="gutter-box">
              <v-form-item label="　联系人">
                <v-input placeholder="联系人" v-model="options.lxr"></v-input>
              </v-form-item>
            </div>
          </v-col>
          <v-col class="gutter-row" span="6">
            <div class="gutter-box">
              <v-form-item  label="联系人电话">
                <v-input placeholder="联系人电话" v-model="options.lxrdh"></v-input>
              </v-form-item>
            </div>
          </v-col>
          <v-col class="gutter-row" span="6">
            <div class="gutter-box">
              <v-form-item  label="　　邮箱地址">
                <v-input placeholder="邮箱地址" v-model="options.yxdz"></v-input>
              </v-form-item>
            </div>
          </v-col>
        </v-row>
        <v-row :gutter="24">
          <v-col class="gutter-row" span="6">
            <div class="gutter-box">
              <v-form-item  label="状态">
                <v-switch v-model="checked"></v-switch>
              </v-form-item>
            </div>
          </v-col>
        </v-row>
        <v-row :gutter="24">
          <v-col class="gutter-row" span="24">
            <div class="gutter-box">
              <v-button type="success" html-type="button"  @click="save()">保存</v-button>
            </div>
          </v-col>
        </v-row> -->
        <v-row :gutter="24">
          <v-col class="gutter-row" span="8">
            <div style="text-align: left">
              <v-form-item>
                <v-button type="success" icon="plus" @click="add('')"
                  ><span>添加</span></v-button
                >
              </v-form-item>
            </div>
          </v-col>
          <v-col class="gutter-row" span="16">
            <div style="text-align: right">
              <v-form-item>
                <v-input
                  placeholder="输入名称或客户编号"
                  v-model="cx"
                ></v-input>
              </v-form-item>
              <v-form-item>
                <v-button type="primary" icon="search" @click="findList()"
                  ><span>检索</span></v-button
                >
              </v-form-item>
            </div>
          </v-col>
        </v-row>
      </v-form>
    </div>
    <br />
    <vxe-grid
      v-bind="xGridOptions"
      size="mini"
      stripe
      highlight-current-row
      highlight-hover-row
      ref="xTable"
      :data="tableData"
    >
      <!--自定义插槽 cz-->
      <template v-slot:cz="{ row }">
        <span>
          <span>
            <a class="link" @click="add(row)" title="修改">
              <v-icon type="edit"></v-icon>
            </a>
            &nbsp;&nbsp;
            <v-popconfirm
              title="确定删除吗?"
              @confirm="del(row)"
              @cancel="cancel"
              placement="bottomRight"
            >
              <a class="link" title="删除">
                <v-icon type="delete"></v-icon>
              </a>
            </v-popconfirm>
          </span>
        </span>
      </template>
      <template v-slot:empty>
        <span style="color: red">
          <p>未搜索到结果！</p>
        </span>
      </template>
    </vxe-grid>
  </v-card>
</template>
<script>
let options = {
  id: "",
  xjlx_dm: "",
  xjlx_mc: "",
  bz: "",
};
export default {
  data() {
    return {
      options,
      checked: true,
      tableData: [],
      cx: "",
      xGridOptions: {
        showOverflow: true,
        resizable: true,
        height: 500,
        headerAlign: "center",
        checkboxConfig: {
          labelField: "id",
          highlight: true,
          range: true,
        },
        editConfig: {
          trigger: "", //click可以编辑表格
          mode: "row",
          showStatus: true,
        },
        columns: [
          {
            type: "seq",
            title: "序号",
            width: 70,
            align: "center",
          },
          {
            field: "khbh",
            title: "客户编号",
            align: "center",
          },
          {
            field: "khjc",
            title: "客户简称",
            align: "center",
          },
          {
            field: "khmc",
            title: "客户名称",
            align: "center",
          },
          {
            field: "dq",
            title: "地区/分组",
            align: "center",
          },
          {
            field: "khdz",
            title: "客户地址",
            align: "center",
          },
          {
            field: "shxydm",
            title: "社会信用代码",
            align: "center",
          },
          {
            field: "khdh",
            title: "联系电话",
            align: "center",
          },
          {
            field: "lxr",
            title: "联系人",
            align: "center",
          },
          {
            field: "lxdh",
            title: "联系人电话",
            align: "center",
          },
          {
            field: "yxdz",
            title: "邮箱地址",
            align: "center",
          },
          {
            field: "xy_bz",
            title: "状态",
            align: "center",
            slots: {
              default: ({ row, column }) => {
                let xy_bz = row.xy_bz == 1 ? "启用" : "禁用";
                return [<span>{xy_bz}</span>];
              },
            },
          },
          {
            field: "cz",
            title: "操作",
            align: "center",
            slots: {
              // 对应自定义插槽的名称
              default: "cz",
            },
          },
        ],
      },
    };
  },
  created() {
    this.findList();
  },
  methods: {
    findList() {
      this.$axios.get("api/system/khwh/get-khwh-list?cx=" + this.cx).then((res) => {
        this.tableData = res.data.data;
      });
    },
    add: function (row) {
      let khbh = row == "" ? "" : row.khbh;
      let title = row == "" ? "添加客户" : "修改客户";
      xadmin.open(title, "/khwhadd?khbh=" + khbh, "800", "500");
    },
    del: function (row) {
      this.$axios
        .get("api/system/khwh/del-khwh-list?khbh=" + row.khbh)
        .then((res) => {
          if (res.data.code == 200) {
            this.$message["success"](res.data.message);
            this.findList();
          } else {
            this.$message["error"](res.data.message);
          }
        });
    },
    cancel: function () {
      this.$message.info("取消删除");
    },
  },
};
</script>


<style>
</style>


// WEBPACK FOOTER //
// src/view/xtgl/jcsj/khwh.vue